import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PlatformControl} from '../../../../controls/core/platform/platform.control';

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
})
export class PdfPreviewComponent implements OnInit, OnChanges {

  @Input() blob: any;
  @Input() src: string;
  @Input() fileName = 'pdf.pdf';
  @Input() displayDownloadButton = false;
  @Input() displayPrintButton = false;

  pdfSrc: string;

  constructor(private platformControl: PlatformControl) { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.src) {
      this.pdfSrc = this.src;
    } else if (this.blob) {
      this.pdfSrc = window.URL.createObjectURL(this.blob);
    }
  }

  download(){
    const anchor = document.createElement('a');
    anchor.download = this.fileName;
    anchor.href = this.pdfSrc;
    anchor.click();
  }

  print() {
    if (this.platformControl.isFirefox()) {
      const printWindow = window.open(this.pdfSrc);
      printWindow.onload = function() {
        printWindow.print();
      };
    } else {
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = this.pdfSrc;
      document.body.appendChild(iframe);
      iframe.contentWindow.print();
    }
  }
}
